module.exports = __webpack_public_path__ + "static/half_plate-05256c0efa7a30c3b15386b1c49649c4.jpg";